import type { AlchemyType } from '@/domain/genetics/types';
import { enemiesForBiome } from '@/domain/combat/enemy-defs';
import { exposureMultiplier } from './exposure';
import type { BiomeId, ItemType } from './types';

const RESOURCES: Record<BiomeId, ItemType[]> = {
  meadow: ['berry', 'flower'],
  forest: ['berry', 'flower', 'crystal'],
  cave: ['crystal', 'shell'],
  coast: ['shell', 'flower'],
};

export type ExpeditionRisk = 'favorable' | 'neutral' | 'hostile';

export interface ExpeditionBriefing {
  risk: ExpeditionRisk;
  enemyTypes: AlchemyType[];
  resources: ItemType[];
}

export function expeditionBriefing(biome: BiomeId, creatureTypes: AlchemyType[]): ExpeditionBriefing {
  const exposure = exposureMultiplier(biome, creatureTypes);
  const risk: ExpeditionRisk = exposure < 0.9 ? 'favorable' : exposure > 1.1 ? 'hostile' : 'neutral';
  return {
    risk,
    enemyTypes: [...new Set(enemiesForBiome(biome).map((enemy) => enemy.type))],
    resources: RESOURCES[biome],
  };
}
